var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7576 1.34855H14.0548V0.67427C14.0548 0.433305 13.9209 0.210712 13.7035 0.0903053C13.4861 -0.0301017 13.2181 -0.0301017 13.0007 0.0903053C12.7833 0.210712 12.6494 0.433313 12.6494 0.67427V1.34855H9.83839V0.67427C9.83839 0.433305 9.70443 0.210712 9.48702 0.0903053C9.26961 -0.0301017 9.00168 -0.0301017 8.78428 0.0903053C8.56687 0.210712 8.43291 0.433313 8.43291 0.67427V1.34855H5.62194V0.67427C5.62194 0.433305 5.48798 0.210712 5.27057 0.0903053C5.05315 -0.0301017 4.78523 -0.0301017 4.56782 0.0903053C4.35042 0.210712 4.21645 0.433313 4.21645 0.67427V1.34855H3.51371C2.58212 1.3496 1.68907 1.7051 1.03042 2.33723C0.37161 2.96921 0.00108423 3.82608 0 4.71994V14.1599C0.00109804 15.0537 0.371606 15.9106 1.03042 16.5426C1.68907 17.1747 2.58212 17.5302 3.51371 17.5312H14.7576C15.6892 17.5302 16.5822 17.1747 17.2409 16.5426C17.8997 15.9106 18.2702 15.0537 18.2713 14.1599V4.71994C18.2702 3.82608 17.8997 2.96921 17.2409 2.33723C16.5822 1.70511 15.6892 1.34959 14.7576 1.34855ZM1.40548 4.71994C1.40548 4.18337 1.6276 3.66896 2.02289 3.28951C2.41834 2.91023 2.95449 2.69711 3.51371 2.69711H4.21645V3.37139C4.21645 3.61235 4.35041 3.83494 4.56782 3.95535C4.78524 4.07576 5.05316 4.07576 5.27057 3.95535C5.48797 3.83494 5.62194 3.61234 5.62194 3.37139V2.69711H8.43291V3.37139C8.43291 3.61235 8.56686 3.83494 8.78428 3.95535C9.00169 4.07576 9.26961 4.07576 9.48702 3.95535C9.70443 3.83494 9.83839 3.61234 9.83839 3.37139V2.69711H12.6494V3.37139C12.6494 3.61235 12.7833 3.83494 13.0007 3.95535C13.2181 4.07576 13.4861 4.07576 13.7035 3.95535C13.9209 3.83494 14.0548 3.61234 14.0548 3.37139V2.69711H14.7576C15.3168 2.69711 15.8529 2.91023 16.2484 3.28951C16.6437 3.66894 16.8658 4.18337 16.8658 4.71994V6.0685H1.40548V4.71994ZM16.8658 14.1599C16.8658 14.6964 16.6437 15.2108 16.2484 15.5903C15.8529 15.9696 15.3168 16.1827 14.7576 16.1827H3.51371C2.95449 16.1827 2.41836 15.9696 2.02289 15.5903C1.6276 15.2109 1.40548 14.6964 1.40548 14.1599V7.41706H16.8658V14.1599Z",
    fill: "#84858A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.32233,
    y: 8.76562,
    width: 1.66103,
    height: 1.59375,
    rx: 0.796875,
    fill: "#84858A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.32233,
    y: 11.9531,
    width: 1.66103,
    height: 1.59375,
    rx: 0.796875,
    fill: "#84858A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.30499,
    y: 8.76562,
    width: 1.66103,
    height: 1.59375,
    rx: 0.796875,
    fill: "#84858A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.30499,
    y: 11.9531,
    width: 1.66103,
    height: 1.59375,
    rx: 0.796875,
    fill: "#84858A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2881,
    y: 8.76562,
    width: 1.66103,
    height: 1.59375,
    rx: 0.796875,
    fill: "#84858A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2881,
    y: 11.9531,
    width: 1.66103,
    height: 1.59375,
    rx: 0.796875,
    fill: "#84858A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6bfbf7bfb33816196f9d6d92a3e0baed.svg";
export { ForwardRef as ReactComponent };